import 'bootstrap/dist/css/bootstrap.css';
import 'react-toastify/dist/ReactToastify.css';

import React from 'react';
import { Toaster } from 'sonner';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import { AuthProvider } from './AuthContext';
import { sentryEnvironment } from './globalSettings';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

Sentry.init({
  dsn: 'https://7121e461e2ebff20bcaa41419b1913e4@o4506559007227904.ingest.us.sentry.io/4509866782883840',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: sentryEnvironment,
  sendDefaultPii: true,
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <BrowserRouter>
            <ToastContainer position='top-right' />
            <Toaster position='top-left' duration={5000} theme='light' richColors visibleToasts={3} />
            <App />
          </BrowserRouter>
        </AuthProvider>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}
